import styled from 'styled-components';

const FormItem = styled.div`
  margin-bottom: var(--spacing);
`;

export default FormItem;
